//import React from "react";
import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Career from "../Career/Career";
import "./CareerLanding.css";
import { useNavigate } from "react-router-dom";
import welcomecareer from "../../Images/start-trading.png"
import CallTrackApi from "../Activity_Track/CallTrackApi";
function CareerLanding() {
    let navigate = useNavigate();
    const [data, setData] = useState([]);
    const [dataDept, setDataDept] = useState([]);
    const [dataLoc, setDataLoc] = useState([]);
    const [mapData, setMapdata] = useState([]);
    var [filterLocation, setFilterLocation] = useState([]);
    var [filterDepartment, setFilterDepartment] = useState([]);
    // const [commdata, setcommData] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState([]);
    var main_dept = ""
    const [unique_department, setUniqueDepartment] = useState([]);




    const [deptid, setdeptid] = useState("All Department");
    const [locid, setlocid] = useState("All Location");
    const [typeid, settypeid] = useState("All Work Type");

    // const [selectedLocation, setselectedLocation] = useState([]);
    // const [selectedLocation, setselectedLocation] = useState([]);

    const routeChangeToCareer = (job_id) => {
        
        navigate("/Careers/" + job_id, {
           
            //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };



    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

        postData('/api/Login/Career')
            .then((data) => {
                if (data.data != null && data.data.length > 0) {
                    setData(data.data);
                    setMapdata(data.data);

                    //console.log("data_all: ", data)
                    setUniqueDepartment(Array.from(new Set(data.data.map(item => item.department))))
                    //console.log("unique_department:" + unique_department);
                }
                else { setData(null); setMapdata(null); }
            });
    }, [dataDept, dataLoc]);
    useEffect(() => {

        postData('/api/Login/Careerdepartment', { "deptid": "deptid", "dept": "dept" })
            .then((dataDept) => {
                if (dataDept.data != null && dataDept.data.length > 0) {
                    setDataDept(dataDept.data);
                    setMapdata(dataDept.data)
                    //console.log("data_dept: ", dataDept)
                    // setUniqueDepartment(Array.from(new Set(data.data.map(item => item.department))))
                }
                else { setDataDept(null); }
            });
    }, []);
    useEffect(() => {

        postData('/api/Login/CareerLocation', { "locid": "locid" })
            .then((dataLoc) => {
                if (dataLoc.data != null && dataLoc.data.length > 0) {
                    setDataLoc(dataLoc.data);
                    setMapdata(dataLoc.data)
                    //console.log("data_loc: ", dataLoc)
                    // setUniqueDepartment(Array.from(new Set(data.data.map(item => item.department))))
                }
                else { setDataLoc(null); }
            });
    }, []);

    function handleSelectChange(event, filterName) {
        //setSelectedLocation(event.target.value);



        const filtered2 = data.filter(one_data => {

            if (filterName == "dept" && event.target.value != "All Department") {
                setdeptid(event.target.value);
                if (typeid != "All Work Type" && locid != "All Location") {

                    return one_data.department === event.target.value && one_data.job_title === typeid && one_data.location === locid;
                }
                else if (typeid != "All Work Type") {

                    return one_data.department === event.target.value && one_data.job_title === typeid;
                }
                else if (locid != "All Location") {

                    return one_data.department === event.target.value && one_data.location === locid;
                }
                else {

                    return one_data.department === event.target.value;
                }

            }
            else if (filterName == "dept" && event.target.value == "All Department") {

                setdeptid(event.target.value);
                if (typeid != "All Work Type" && locid != "All Location") {

                    return one_data.job_title === typeid && one_data.location === locid;
                }
                else if (typeid != "All Work Type") {

                    return one_data.job_title === typeid;
                }
                else if (locid != "All Location") {

                    return one_data.location === locid;
                }
                else return one_data;
            }
            if (filterName == "job_title" && event.target.value != "All Work Type") {
                settypeid(event.target.value);
                if (deptid != "All Department" && locid != "All Location") {

                    return one_data.job_title === event.target.value && one_data.department === deptid && one_data.location === locid;
                }
                else if (deptid != "All Department") {

                    return one_data.job_title === event.target.value && one_data.department === deptid;
                }
                else if (locid != "All Location") {

                    return one_data.job_title === event.target.value && one_data.location === locid;
                }
                else {

                    return one_data.job_title === event.target.value;
                }

            }
            else if (filterName == "job_title" && event.target.value == "All Work Type") {
                settypeid(event.target.value);
                if (deptid != "All Department" && locid != "All Location") {

                    return one_data.department === deptid && one_data.location === locid;
                }
                else if (deptid != "All Department") {

                    return one_data.department === deptid;
                }
                else if (locid != "All Location") {

                    return one_data.location === locid;
                }
                else    return one_data;

            }

            if (filterName == "location" && event.target.value != "All Location") {
                setlocid(event.target.value);
                if (deptid != "All Department" && typeid != "All Work Type") {
                    return one_data.location === event.target.value && one_data.department === deptid && one_data.job_title === typeid;
                }
                else if (deptid != "All Department") {
                    return one_data.location === event.target.value && one_data.department === deptid;
                }
                else if (typeid != "All Work Type") {
                    return one_data.location === event.target.value && one_data.job_title === typeid;
                }
                else
                    return one_data.location === event.target.value;
            }
            else if (filterName == "location" && event.target.value == "All Location") {
                setlocid(event.target.value);
                if (deptid != "All Department" && typeid != "All Work Type") {
                    return one_data.department === deptid && one_data.job_title === typeid;
                }
                else if (deptid != "All Department") {
                    return one_data.department === deptid;
                }
                else if (typeid != "All Work Type") {
                    return one_data.job_title === typeid;
                }
                else return one_data;
            }

        })

        setMapdata(filtered2);

    }

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header

        });
        // console.log(response, "careerdata");
        return response.json(); // parses JSON response into native JavaScript objects

    }
    CallTrackApi("Careers",window.location.href);

    return (
        <> 
		 <div className="careeerlist_page">
		<section className="careeerlistwelcome_section">
                    <Container>
                        <Row>
                            <Col xl={7} md={12} sm={12}>
                            <div className="commoninnerhero_text">
                            <h2>Career</h2>
                             <h1 className="herotextColorHeading otro-blockquote"> The best way to predict the future is to create it. <i> <br></br>—Abraham Lincoln</i> </h1>
                                <h3>With us, take your career to the next level</h3>
                                </div>
                            </Col>
                            <Col xl={5} md={12} sm={12}>
                                <div className="researchbanner_imgpanel text-right">
                                    <img src={welcomecareer} alt="/static/media/Research.7379c47b.png" className="img-fluid"></img>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
				
				<section className="career-landing-sc">
                    <Container>
                        <div className="career-main">
                        <div className="filter-pnl">
                             <label>FILTER BY:</label>
                             <div className="filterinput_grid">
                                <div className="filter-select">
                                    
                                    {/* aria-label="Select Department" */}
                                    <select aria-label="Select Department" value={deptid} onChange={(e) => handleSelectChange(e, "dept")}>
                                        <option value="All Department">All Department</option>
                                        {dataDept &&
                                            dataDept.map(
                                                ({ dept }) => (
                                                    <option>{dept}</option>
                                                )
                                            )}
                                    </select>
                                </div>
                                                
                                <div className="filter-select">
                                   
                                   {/* aria-label="Select Work Type" */}
                                    <select aria-label="Select Work Type" value={typeid} onChange={(e) => handleSelectChange(e, "job_title")}>
                                        <option value="All Work Type">All Work Type</option>
                                        {data &&
                                            data.map(
                                                ({ job_title }) => (
                                                    <option>{job_title}</option>
                                                )
                                            )}
                                    </select>
                                </div>
                               
                                <div className="filter-select">
                                    
                                    {/* aria-label="Select Location" */}
                                    <select aria-label="Select Location" value={locid} onChange={(e) => handleSelectChange(e, "location")} >
                                        <option value="All Location">All Location</option>
                                        {dataLoc &&
                                            dataLoc.map(
                                                ({ location }) => (
                                                    <option>{location}</option>
                                                )
                                            )}
                                    </select>
                                </div>
                                </div>
                               
                               
                            </div>                             
                            {/* <div className="career-header">
                                <h2>Technology</h2>
                            </div> */}

                           

                            {/*E {unique_department && unique_department.map((main_unique_department) => {
                                    return <>
                                        <div className="career-sub-header">
                                            <h5>{main_unique_department}</h5>
                                        </div> */}
						<div className="row">
                            {mapData && mapData.map(({ job_title, location, department, job_id }) => {
                                //if (main_unique_department == department) {
                                return( 
                                <div className="col-md-4 col-sm-6">
                                    <div className="career_group">
                                    <div className="career_panel">
                                        <div className="career-sub-header">
                                            <h5>{department}</h5>
                                        </div>
                                        <div className="career-list-data">
                                            <h6>{job_title}</h6>
                                            <p>{location} /{department}  </p>
                                        </div>
                                        <div className="career-list-btn">
                                            <a onClick={() => { routeChangeToCareer(job_id) }}>Apply</a>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                

                            )})}
					    </div>
                            {/* </>
                                })}
                                */}
                        </div>


                    </Container>
                </section>
				</div>
            
        </>
    )
}

export default CareerLanding;